import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { Subscription } from 'rxjs';
import { collabDto } from 'src/app/models/collabDto';
import { FormVendeurModifComponent } from 'src/app/pages/page-entites/form-vendeur-modif/form-vendeur-modif.component';
import { collabService } from 'src/app/services/collab/collabService.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-liste-vendeurs',
  templateUrl: './liste-vendeurs.component.html',
  imports:[DialogModule, ToastModule,CommonModule, ReactiveFormsModule, FormsModule,TableModule,FormVendeurModifComponent,ButtonModule],
  styleUrls: ['./liste-vendeurs.component.scss'],

  providers: [MessageService]

})
export class ListeVendeursComponent implements OnInit, OnDestroy {

  private subsc: Subscription = new Subscription;
  handleClose() {
    this.collab.getcollab().subscribe(data => {
      this.vendeurs = data;


    })
  }
  getProfil(char: string): string {

    if (char === '1') {

      return 'Admin';
    }

    if (char === '2') {

      return 'Interne';
    }
    if (char === '3' || char === '4') {

      return 'Externe';
    }
    return '';


  }
  vendeurs!: collabDto[];
  constructor(private collab: collabService, private messageService: MessageService, public share: shareOpeSevices) {


  }

  ngOnInit() {
    this.subsc = this.share.isRefrechVendeurs$.subscribe(() => {
      this.collab.getcollab().subscribe(data => {
        this.vendeurs = data;
      })
    })
  }

  ngOnDestroy() {
    this.subsc.unsubscribe();
  }
  activer(numCollab: number) {

    this.collab.setActif(numCollab).subscribe({

      next: (response: any) => {

        if (response !== null) {

          this.messageService.add({ severity: 'success', detail: 'Activé avec Success !' });
          this.collab.getcollab().subscribe(data => {
            this.vendeurs = data;

          })

        }
        else {
          this.messageService.add({ severity: 'warn', detail: 'Erreur' });

        }
      }
    }
    )
  }

  showEntiteForm(vendeur: collabDto) {

    this.share.isForModifvendeur = true;
    this.share.sendVendeurfromList(vendeur);
    // this.share.sendFicheEntite(this.entite);
  }

}
